import React from "react";
import {
  MdAddShoppingCart,
  MdPlaylistAdd,
  MdDelete,
  MdRemove,
  MdAdd,
  MdCheck,
} from "react-icons/md";

import styles from "./ItemCardButton.module.scss";

interface ItemCardButtonProps {
  quantity: number;
  showCartButton: boolean;
  showComplexButton: boolean;
  isComplexCategory: boolean;
  isOutOfStock: boolean;
  isIncreaseDisabled: boolean;
  hasPrice: boolean;
  isInComplexCart?: boolean;
  onAddToCart: (e: React.MouseEvent) => void;
  onAddToComplex: (e: React.MouseEvent) => void;
  onIncrease: (e: React.MouseEvent) => void;
  onDecrease: (e: React.MouseEvent) => void;
  onRemove: (e: React.MouseEvent) => void;
}

export const ItemCardButton: React.FC<ItemCardButtonProps> = ({
  quantity,
  showCartButton,
  showComplexButton,
  isComplexCategory,
  isInComplexCart = false,
  hasPrice,
  isOutOfStock,
  isIncreaseDisabled,
  onAddToCart,
  onAddToComplex,
  onIncrease,
  onDecrease,
  onRemove,
}) => {
  const handleClick =
    (handler: (e: React.MouseEvent) => void) => (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();
      handler(e);
    };

  const renderCartQuantity = () => (
    <div className={styles.quantityContainer}>
      <button
        className={styles.iconButton}
        onClick={handleClick(quantity === 1 ? onRemove : onDecrease)}
        aria-label="Уменьшить"
      >
        {quantity === 1 ? <MdDelete size={28} /> : <MdRemove size={28} />}
      </button>
      <span className={styles.quantityText}>{quantity}</span>
      <button
        className={`${styles.iconButton} ${isIncreaseDisabled ? styles.disabled : ""}`}
        onClick={handleClick(onIncrease)}
        disabled={isIncreaseDisabled}
        aria-label="Увеличить"
      >
        <MdAdd size={28} />
      </button>
    </div>
  );

  const renderCartButton = () => (
    <button
      className={`${styles.actionButton} ${!hasPrice || isOutOfStock ? styles.disabled : ""}`}
      onClick={handleClick(onAddToCart)}
      disabled={!hasPrice || isOutOfStock}
    >
      <span className={styles.bgText}>В КОРЗИНУ</span>
      <MdAddShoppingCart size={32} />
    </button>
  );

  const renderComplexButton = () => (
    <button className={styles.actionButton} onClick={handleClick(onAddToComplex)}>
      <span className={styles.bgText}>
        {isInComplexCart ? "В ПРОЕКТЕ" : "В ПРОЕКТ"}
      </span>
      {isInComplexCart ? <MdCheck size={32} /> : <MdPlaylistAdd size={32} />}
    </button>
  );

  if (!showCartButton && !showComplexButton) return null;

  if (showCartButton && showComplexButton) {
    return (
      <div className={styles.wrapper}>
        <div className={styles.splitActionRow}>
          <button
            className={styles.halfActionButton}
            onClick={handleClick(onAddToCart)}
          >
            <span className={styles.halfBgText}>В КОРЗИНУ</span>
            <MdAddShoppingCart size={32} />
          </button>
          <button
            className={styles.halfActionButton}
            onClick={handleClick(onAddToComplex)}
          >
            <span className={styles.halfBgText}>
              {isInComplexCart ? "В ПРОЕКТЕ" : "В ПРОЕКТ"}
            </span>
            {isInComplexCart ? (
              <MdCheck size={32} />
            ) : (
              <MdPlaylistAdd size={32} />
            )}
          </button>
        </div>
      </div>
    );
  }

  if (showCartButton && !showComplexButton) {
    return (
      <div className={styles.wrapper}>
        {quantity > 0 ? renderCartQuantity() : renderCartButton()}
      </div>
    );
  }

  return <div className={styles.wrapper}>{renderComplexButton()}</div>;
};